<template>
    <div>
        <div v-if="! viewport.isMobile" class="content--title mb-1">{{ $t('priceList.calculatedPriceHeadline') }}</div>

        <ul class="product--base-info sizing--product list--unordered">
            <li v-for="(position, key) in positions"
                class="base-info--entry mb-1"
                @click="activatePlexipeople(position)"
                :class="{ 'is--active': activePlexipeople.uuid === position.uuid }">
                <template v-if="! viewport.isMobile"><template v-if="'cake-topper' !== base.color.class">Aktuelle Plexipeople Größe: {{ position.values.width }} x {{ position.values.height }} cm</template><template v-else>CakeTopper</template></template>
                <template v-else><template v-if="'cake-topper' !== base.color.class">{{ position.label }}: {{ position.values.width }} x {{ position.values.height }} cm</template><template v-else>CakeTopper</template></template>
            </li>
        </ul>
    </div>
</template>

<script>
    import EventBus from '../event-bus';

    export default {
        data() {
            return {
                positions: [],
                sum: .0
            };
        },

        props: {
            viewport: Object,
            base: Object,
            plexipeople: Array,
            activePlexipeople: Object
        },

        methods: {
            activatePlexipeople(position) {
                this.$emit('activatePlexipeople', position);
            },

            calculatePrices() {
                EventBus.$emit('addLeavingEditorEventListener');

                // console.log('calculatePrices called');
                if (0 === this.plexipeople.length) {
                    this.positions = [];
                    this.$emit('priceUpdated', .0);

                    return;
                }

                let vm          = this,
                    requestBody = {
                        quantity: 1,                        // number of configured product
                        base: {                             // false on order without base
                            autoWidth: vm.base.autoWidth,
                            material: {
                                id: App.configuration.variants.materials.id,
                                value: vm.base.material
                            },
                            color: {
                                id: App.configuration.variants.colors.id,
                                value: vm.base.color
                            },
                            grooves: {
                                id: App.configuration.variants.grooves.id,
                                value: vm.base.grooves
                            },
                            width: {
                                id: App.configuration.variants.widths.id,
                                value: vm.base.width
                            }
                        },
                        plexipeople: []
                    };

                vm.plexipeople.forEach((position) => {
                    requestBody.plexipeople.push({
                        uuid: position.uuid,
                        indicator: position.indicator,
                        groove: position.groove,
                        height: (position.height / vm.viewport.factor) * 10,
                        width: (position.width / vm.viewport.factor) * 10
                    });
                });

                vm.$http.post(App.url.priceCalculator, requestBody).then(
                    // Successful
                    response => {
                        vm.positions = response.data.positions;
                        vm.sum       = response.data.sum;

                        if (! vm.positions) {
                            return;
                        }

                        let base = vm.positions[vm.positions.length - 1];

                        if (
                            true === requestBody.base.autoWidth
                            && requestBody.base.width.value.id !== base.values.width.id
                        ) {
                            vm.$emit('baseWidthChanged', base.values.width.id);
                        }

                        vm.positions.splice(vm.positions.length - 1, 1);

                        vm.positions.forEach(position => {
                            let i = 0;

                            for (; i < vm.plexipeople.length; i ++) {
                                if (vm.plexipeople[i].uuid !== position.uuid) {
                                    continue;
                                }

                                vm.plexipeople[i].size = position.size || 'S';
                                vm.plexipeople[i].color = requestBody.base.color.value;
                            }
                        });

                        vm.$emit('priceUpdated', vm.sum);
                    },
                    // Errors occurs
                    response => {
                        // alert('Kapott');
                    }
                );
            }
        },

        mounted() {
            EventBus.$on('calculatePrices', this.calculatePrices);
            // window.setTimeout(this.calculatePrices, 500);
        },

        beforeDestroy() {
            EventBus.$off('calculatePrices', this.calculatePrices);
        }
    }
</script>

<style scoped lang="scss">
    @import "../assets/scss/components/price-list";
</style>



// WEBPACK FOOTER //
// src/components/PriceList.vue